import React from "react";
import reCodeImg from "../../assets/images/webp/other/re-code-img.webp";
import { RE_WATER_LIST } from "../../utils/other-component";
import Icons from "../common/components/Icons";
import BlueTag from "../common/ui/BlueTag";
import Heading from "../common/ui/Heading";

const ReWater = () => {
  return (
    <>
      <div className="px-4 py-[140px] max-xl:py-[120px] max-lg:py-24 max-md:py-20 max-sm:py-10">
        <div className="w-full max-w-[1140px] flex items-center max-xl:gap-8 max-xl:items-start max-lg:flex-wrap-reverse  justify-between mx-auto">
          <div className="w-full max-w-[484px]">
            <img
              src={reCodeImg}
              alt="re-code"
              className="w-full object-contain"
              width={484}
              height={424}
            />
          </div>
          <div className="w-full max-w-[586px] max-lg:max-w-full">
            <BlueTag>Re-Code Water Matka</BlueTag>
            <Heading>The World's First Consciousness-Based Earthen Pot</Heading>

            <div className="flex flex-wrap w-full gap-6 max-w-[586px] max-lg:max-w-full mt-[32px] max-md:mt-5">
              {RE_WATER_LIST.map((obj, i) => (
                <div
                  key={i}
                  className={`py-[10.5px] px-[14px] border rounded-[7px] border-solid border-[#128D484D] bg-[#EAF3EE] flex items-center gap-1 transition-all ease-linear duration-300 hover:scale-95`}>
                  <p>{obj.icon}</p>
                  <p className="text-base text-[#001A3D] leading-[130%] font-bold ff-jakarta">
                    {obj.name}
                  </p>
                </div>
              ))}
            </div>
            <div className="flex items-center gap-2 pt-6 max-md:pt-4">
              <Icons icon="CheckIcon" />{" "}
              <p className="text-[#001A3D] font-semibold text-lg leading-[19.31px] ">
                Transformation begins...
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReWater;
